import React from 'react'
import { Skeleton } from '@mui/material'
import { styled } from '@mui/system'

const SkeletonContainer = styled('div')({
	padding: '16px',
	backgroundColor: '#fff',
})

const HeaderSkeleton = styled('div')({
	display: 'flex',
	alignItems: 'center',
	marginBottom: '24px',
})

const ContentContainer = styled('div')({
	display: 'flex',
	gap: '24px',
})

const MainContent = styled('div')({
	flex: 1,
})

const Sidebar = styled('div')({
	width: '300px',
	display: 'none',
	'@media (min-width: 1024px)': {
		display: 'block',
	},
})

const VideoGrid = styled('div')({
	display: 'grid',
	gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
	gap: '16px',
})

const PageSkeleton = () => {
	return (
		<SkeletonContainer>
			<HeaderSkeleton>
				<Skeleton variant='circular' width={40} height={40} />
				<Skeleton variant='text' width={200} height={40} style={{ marginLeft: '16px' }} />
				<Skeleton variant='text' width={400} height={40} style={{ marginLeft: 'auto' }} />
			</HeaderSkeleton>

			<ContentContainer>
				<MainContent>
					<Skeleton variant='rectangular' width='100%' height={400} style={{ marginBottom: '24px' }} />

					<VideoGrid>
						{[...Array(8)].map((_, index) => (
							<div key={index}>
								<Skeleton variant='rectangular' width='100%' height={140} />
								<Skeleton variant='text' width='100%' height={20} style={{ marginTop: '8px' }} />
								<Skeleton variant='text' width='60%' height={20} style={{ marginTop: '8px' }} />
							</div>
						))}
					</VideoGrid>
				</MainContent>

				<Sidebar>
					{[...Array(5)].map((_, index) => (
						<div key={index} style={{ marginBottom: '16px' }}>
							<Skeleton variant='rectangular' width='100%' height={100} />
							<Skeleton variant='text' width='100%' height={20} style={{ marginTop: '8px' }} />
							<Skeleton variant='text' width='60%' height={20} style={{ marginTop: '8px' }} />
						</div>
					))}
				</Sidebar>
			</ContentContainer>
		</SkeletonContainer>
	)
}

export default PageSkeleton
